import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { View, Image, ScrollView, Modal, TouchableOpacity, Platform } from 'react-native'

import api from "../utils/api"
import tw from '../styles/tailwind';
import Text from './Text';
import { Illustration } from './Illustration';



import Button from './Forms/Button';


import * as ImagePickerNative from 'expo-image-picker';
import * as DocumentPicker from 'expo-document-picker';


import Svg, { Path } from "react-native-svg"
import { Ionicons } from '@expo/vector-icons';


const FilePicker = forwardRef(({
  onFileSelected, style, label, initialImage = null, postUrl = "/images",
  hideButton=false,
  acceptedMimes = ["image/*", "application/pdf"],
  extraData = null
}, ref) => {
  const [image, setImage] = useState(initialImage);
  const [uploading, setUploading] = useState(false);
  const [uploadingProgress, setUploadingProgress] = useState(0);
  const [uploaded, setUploaded] = useState(false);
  const [uploadError, setUploadError] = useState(false);
  const [isPDF, setIsPDF] = useState(initialImage?.uri?.endsWith('pdf') ? true : false);

  useImperativeHandle(ref, () => {
    return {
      pickFile() {
        pickFile()
      },
    };
  }, []);

  const pickFile = async () => {
    // No permissions request is necessary for launching the image library

    let result = await DocumentPicker.getDocumentAsync({
      type: acceptedMimes,
      // allowsEditing: true,
      // aspect: [4, 3],
      // quality: 1,
    });

    console.log(result);

    if (result.canceled === false) {
      const selectedFile = result.assets[0]

      if (selectedFile.mimeType?.startsWith('image')){
        setImage(selectedFile)
        setIsPDF(false)
      } else {
        setIsPDF(true)
        setImage(null)
      }
      // setImage(result.assets[0]);
      if(Platform.OS === "web"){
        uploadImage(selectedFile.file)
      }else{
        uploadImage(selectedFile.uri)
      }
    }
  };


  const fetchImageFromUri = async (uri) => {
    const response = await fetch(uri);
    const blob = await response.blob();
    return blob;
  };


  async function uploadImage(pickerResult) {
    const formData = new FormData();

    if (Platform.OS === "web") {
      const image = await fetchImageFromUri(pickerResult.uri)

      // formData.append('image', image, 'image.jpg');
      formData.append('image', pickerResult);

      if (extraData) {
        for (const key in extraData) {
          if (extraData.hasOwnProperty(key)) {
            formData.append(key, extraData[key]);
          }
        }
      }
    } else {
      const localUri = Platform.OS === 'ios' ? pickerResult.replace('file://', '') : pickerResult
      const filename = localUri.split('/').pop();

      // Infer the type of the image
      const match = /\.(\w+)$/.exec(filename);
      const type = match ? `image/${match[1]}` : `image/jpeg`;

      formData.append('image', {
        name: "image.jpg",
        type: type,
        uri: localUri,
      });


      if(extraData){
        for (const key in extraData) {
          if (extraData.hasOwnProperty(key)) {
            formData.append(key, extraData[key]);
          }
        }
      }
    }

    try {
      setUploading(true)
      setUploadingProgress(0)
      setUploadError(false)
      setUploaded(false)

      const response = await api.post(postUrl, formData, {
        headers: { "Accept": "application/json", "Content-Type": "multipart/form-data" },
        timeout: 30000,
        onUploadProgress,
      })
        .then(({ data }) => {
          // console.log(data);
          onFileSelected?.(data)
          setUploaded(true)
          setUploading(false)
          setUploadingProgress(0)
        })
    } catch (error) {
      setUploading(false)
      setUploadingProgress(0)
      setUploadError(error.response?.data?.message ?? "Error al subir imagen")

      console.log("Error:", error)
      console.log("Error:", error.response?.data)
    }
  }

  const onUploadProgress = (progressEvent) => {
    const { loaded, total } = progressEvent;
    let percent = Math.floor((loaded * 100) / total);

    if (percent < 100) {
      setUploadingProgress(percent)

      console.log(`${loaded} bytes of ${total} bytes. ${percent}%`);
    }
  };

  return (
    <View style={tw.style(style?.container)}>
      {
        (hideButton !== true && ! uploading) &&
          <Button
            label={label ?? "Seleccionar Archivo"}
            onPress={pickFile}
            style={{ container: tw.style(`row bg-transparent border border-gray-300`, style?.button) }}
            labelColor={tw.color('gray-500')}
            icon={
              <Ionicons name='cloud-upload-outline' size={20} style={tw`mr-5`} color={tw.color('gray-500')} />
            }
          />
      }

      {(image && !isPDF) && <Image source={{ uri: image.uri }} style={tw.style(`w-[200px] h-[150px] self-center`, style?.image)} resizeMode="contain" />}

      {isPDF && <Illustration name="pdfIcon" width={1000} height={150} style={tw.style(`self-center`, style?.image)} />}

      {
        uploading &&
          <View style={tw`h-1 bg-gray-300 rounded`}>
            <View style={tw`h-1 bg-primary w-[${uploadingProgress}%] rounded`}></View>
          </View>
      }

      {
        uploaded &&
          (Platform.OS !== "web" ?
            <Svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              fill={tw.color('primary')}
              style={tw`absolute bottom-2 left-2`}
            >
              <Path d="m10.6 13.8-2.175-2.175q-.275-.275-.675-.275t-.7.3q-.275.275-.275.7 0 .425.275.7L9.9 15.9q.275.275.7.275.425 0 .7-.275l5.675-5.675q.275-.275.275-.675t-.3-.7q-.275-.275-.7-.275-.425 0-.7.275ZM12 22q-2.075 0-3.9-.788-1.825-.787-3.175-2.137-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175 1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138 1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175-1.35 1.35-3.175 2.137Q14.075 22 12 22Z" />
            </Svg>
          :
            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} style={tw`absolute bottom-2 left-2`} fill={tw.color('primary')}>
              <path d="m10.6 13.8-2.175-2.175q-.275-.275-.675-.275t-.7.3q-.275.275-.275.7 0 .425.275.7L9.9 15.9q.275.275.7.275.425 0 .7-.275l5.675-5.675q.275-.275.275-.675t-.3-.7q-.275-.275-.7-.275-.425 0-.7.275ZM12 22q-2.075 0-3.9-.788-1.825-.787-3.175-2.137-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175 1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138 1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175-1.35 1.35-3.175 2.137Q14.075 22 12 22Z" />
            </svg>)
      }

      {
        uploadError &&
          (Platform.OS !== "web" ?
            <Svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              style={tw`absolute bottom-2 left-2`}
              fill="#f00"
            >
              <Path d="m8.4 17 3.6-3.6 3.6 3.6 1.4-1.4-3.6-3.6L17 8.4 15.6 7 12 10.6 8.4 7 7 8.4l3.6 3.6L7 15.6Zm3.6 5q-2.075 0-3.9-.788-1.825-.787-3.175-2.137-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175 1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138 1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175-1.35 1.35-3.175 2.137Q14.075 22 12 22Z" />
            </Svg>
          :
            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} style={tw`absolute bottom-2 left-2`} fill="#f00">
              <path d="m8.4 17 3.6-3.6 3.6 3.6 1.4-1.4-3.6-3.6L17 8.4 15.6 7 12 10.6 8.4 7 7 8.4l3.6 3.6L7 15.6Zm3.6 5q-2.075 0-3.9-.788-1.825-.787-3.175-2.137-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175 1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138 1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175-1.35 1.35-3.175 2.137Q14.075 22 12 22Z" />
            </svg>)
      }

      {
        uploadError &&
          <Text style={tw`text-xs text-red text-center`}>{uploadError}</Text>
      }
      
    </View>
  )
})

export default FilePicker